// Avatares JASQ® — recortados de los sets oficiales de ilustración plana
// (teacher portrait set + kids avatar collection). Servidos desde
// /public/avatars/ para que sean inmediatos, sin dependencias externas.
//
// Estructura: por rol y por edad. Cada item es {id, gender?, kind?, url}.

const A = (p) => `/avatars/${p}`;

// ---------------------------------------------------------------------------
// MASCOTA — Búho JASQ® (variantes generadas con Nano Banana).
// Las 4 expresiones planeadas son: classic, celebration, explaining, thinking.
// Si el budget de la API se agotó antes de generar todas, las que falten caen
// automáticamente a la clásica (mantiene la UI siempre operativa).
// Re-ejecutar /app/scripts/generate_owl_mascots.py cuando el budget se reponga
// para crear las variantes restantes.
// ---------------------------------------------------------------------------
export const OWL_CLASSIC = A("mascot/buho-classic.png");
export const OWL_CELEBRATION = A("mascot/buho-celebration.png");
export const OWL_EXPLAINING = A("mascot/buho-explaining.png");
export const OWL_THINKING = A("mascot/buho-thinking.png");

export const MASCOT_OWL = {
  id: "mascot-buho-jasq",
  label: "Zarek (Mascota oficial)",
  url: OWL_CLASSIC,
};

export const MASCOT_GROUP = {
  id: "mascota",
  label: "Mascota oficial Zarek 🦉",
  items: [
    { id: "buho-classic",     url: OWL_CLASSIC },
    { id: "buho-celebration", url: OWL_CELEBRATION },
    { id: "buho-explaining",  url: OWL_EXPLAINING },
    { id: "buho-thinking",    url: OWL_THINKING },
  ],
};

// ---------------------------------------------------------------------------
// KIDS — niños 5-13 (16 portraits divididos en dos grupos por edad)
// ---------------------------------------------------------------------------
// Generados con Nano Banana (gemini-3.1-flash-image-preview) — flat portrait
// con fondo circular en paleta JASQ®. Ver /app/scripts/generate_kids_5_9.py
const KIDS_5_9 = [
  { id: "k59-1", gender: "F", url: A("kids/k59-1.png") },
  { id: "k59-2", gender: "M", url: A("kids/k59-2.png") },
  { id: "k59-3", gender: "F", url: A("kids/k59-3.png") },
  { id: "k59-4", gender: "F", url: A("kids/k59-4.png") },
  { id: "k59-5", gender: "M", url: A("kids/k59-5.png") },
  { id: "k59-6", gender: "M", url: A("kids/k59-6.png") },
  { id: "k59-7", gender: "F", url: A("kids/k59-7.png") },
  { id: "k59-8", gender: "F", url: A("kids/k59-8.png") },
];

const KIDS_10_13 = [
  { id: "k1013-1", gender: "M", url: A("kids/kid-boy-glasses.png") },
  { id: "k1013-2", gender: "M", url: A("kids/kid-boy-brunet.png") },
  { id: "k1013-3", gender: "M", url: A("kids/kid-boy-formal.png") },
  { id: "k1013-4", gender: "F", url: A("kids/kid-girl-buns.png") },
  { id: "k1013-5", gender: "M", url: A("kids/kid-boy-afro2.png") },
  { id: "k1013-6", gender: "F", url: A("kids/kid-girl-bow.png") },
  { id: "k1013-7", gender: "F", url: A("kids/kid-girl-dark-long.png") },
  { id: "k1013-8", gender: "M", url: A("kids/kid-boy-cool.png") },
];

// ---------------------------------------------------------------------------
// TEACHERS — flat portrait illustration set (8 portraits)
// ---------------------------------------------------------------------------
const TEACHERS = [
  { id: "t-1", gender: "M", url: A("teachers/teacher-veteran.png") },
  { id: "t-2", gender: "M", url: A("teachers/teacher-modern-m.png") },
  { id: "t-3", gender: "M", url: A("teachers/teacher-plaid-m.png") },
  { id: "t-4", gender: "M", url: A("teachers/teacher-formal-m.png") },
  { id: "t-5", gender: "F", url: A("teachers/teacher-blonde-f.png") },
  { id: "t-6", gender: "F", url: A("teachers/teacher-dark-f.png") },
  { id: "t-7", gender: "F", url: A("teachers/teacher-mentor-f.png") },
  { id: "t-8", gender: "F", url: A("teachers/teacher-classic-f.png") },
];

// ---------------------------------------------------------------------------
// Adolescentes (14-18) y Jóvenes (19-25) — sets propios generados con Nano
// Banana, distintos de los docentes y de los kids.
// ---------------------------------------------------------------------------
const TEENS_14_18 = [
  { id: "t-skater-m",  gender: "M", url: A("teens/teen-t-skater-m.png") },
  { id: "t-curly-m",   gender: "M", url: A("teens/teen-t-curly-m.png") },
  { id: "t-glasses-m", gender: "M", url: A("teens/teen-t-glasses-m.png") },
  { id: "t-afro-m",    gender: "M", url: A("teens/teen-t-afro-m.png") },
  { id: "t-braids-f",  gender: "F", url: A("teens/teen-t-braids-f.png") },
  { id: "t-bangs-f",   gender: "F", url: A("teens/teen-t-bangs-f.png") },
  { id: "t-pony-f",    gender: "F", url: A("teens/teen-t-pony-f.png") },
  { id: "t-curls-f",   gender: "F", url: A("teens/teen-t-curls-f.png") },
];

const YOUNG_19_25 = [
  { id: "y-curly-m",   gender: "M", url: A("young/young-y-curly-m.png") },
  { id: "y-skater-m",  gender: "M", url: A("young/young-y-skater-m.png") },
  { id: "y-asia-f",    gender: "F", url: A("young/young-y-asia-f.png") },
  { id: "y-afro-f",    gender: "F", url: A("young/young-y-afro-f.png") },
  { id: "y-glasses-m", gender: "M", url: A("young/young-y-glasses-m.png") },
  { id: "y-pink-f",    gender: "F", url: A("young/young-y-pink-f.png") },
  { id: "y-beard-m",   gender: "M", url: A("young/young-y-beard-m.png") },
  { id: "y-art-f",     gender: "F", url: A("young/young-y-art-f.png") },
];

// Avatares modernos v5.6.4 (SVG vectorial, 12 personajes diversos) para 4-10 años.
const KIDS_MODERN = [
  ["F"],["M"],["F"],["M"],["M"],["F"],["M"],["F"],["M"],["F"],["F"],["M"],
].map(([gender], i) => ({
  id: `km-${i + 1}`, gender, url: A(`kids2/m${String(i + 1).padStart(2, "0")}.svg`),
}));

export const AVATAR_GROUPS = [
  {
    id: "g1",
    label: "Niños/as · 4-10 años",
    minAge: 4, maxAge: 10,
    items: [...KIDS_MODERN, ...KIDS_5_9, ...KIDS_10_13],
  },
  {
    id: "g2",
    label: "Pre-adolescentes · 11-15 años",
    minAge: 11, maxAge: 15,
    items: TEENS_14_18,
  },
  {
    id: "g3",
    label: "Jóvenes · 16-25 años",
    minAge: 16, maxAge: 25,
    items: YOUNG_19_25,
  },
  {
    id: "g4",
    label: "Adultos jóvenes · 26-30 años",
    minAge: 26, maxAge: 30,
    items: TEACHERS,
  },
  {
    id: "g5",
    label: "Adultos · 31 años en adelante",
    minAge: 31, maxAge: 200,
    items: [
      { id: "ad-1", url: A("admins/admin-ceo.png") },
      { id: "ad-2", url: A("admins/admin-cto.png") },
      { id: "ad-3", url: A("admins/admin-coo.png") },
      { id: "ad-4", url: A("admins/admin-cfo.png") },
      { id: "ad-5", url: A("admins/admin-lead.png") },
      { id: "ad-6", url: A("admins/admin-ops.png") },
    ],
  },
];

// ---------------------------------------------------------------------------
// Galerías profesionales — admins y franquiciados reutilizan el mismo estilo
// flat portrait que los docentes (a pedido del usuario).
// ---------------------------------------------------------------------------
export const ADMIN_AVATARS = {
  id: "admins",
  label: "Administradores · JASQ HQ",
  items: [
    { id: "adm-ceo", url: A("admins/admin-ceo.png") },
    { id: "adm-cto", url: A("admins/admin-cto.png") },
    { id: "adm-coo", url: A("admins/admin-coo.png") },
    { id: "adm-cfo", url: A("admins/admin-cfo.png") },
    { id: "adm-lead", url: A("admins/admin-lead.png") },
    { id: "adm-ops", url: A("admins/admin-ops.png") },
  ],
};

export const TEACHER_AVATARS = {
  id: "docentes",
  label: "Docentes acompañantes",
  items: TEACHERS,
};

export const FRANCHISEE_AVATARS = {
  id: "franquiciados",
  label: "Franquiciados",
  // Mismos retratos profesionales (subset distinto al de admins para variar)
  items: [
    { id: "fra-1", url: A("teachers/teacher-veteran.png") },
    { id: "fra-2", url: A("teachers/teacher-formal-m.png") },
    { id: "fra-3", url: A("teachers/teacher-classic-f.png") },
    { id: "fra-4", url: A("teachers/teacher-mentor-f.png") },
  ],
};

// ---------------------------------------------------------------------------
// Selectores
// ---------------------------------------------------------------------------
export function avatarGroupForAge(age) {
  if (!age) return AVATAR_GROUPS;
  const n = parseInt(age, 10);
  const match = AVATAR_GROUPS.find((g) => n >= g.minAge && n <= g.maxAge);
  return match ? [match] : AVATAR_GROUPS;
}

export function avatarGroupsForRole(role, age) {
  if (role === "estudiante") return [...avatarGroupForAge(age), MASCOT_GROUP];
  if (role === "docente") return [TEACHER_AVATARS, MASCOT_GROUP];
  if (role === "franquiciado") return [FRANCHISEE_AVATARS, MASCOT_GROUP];
  if (role === "admin") return [ADMIN_AVATARS, MASCOT_GROUP];
  return AVATAR_GROUPS;
}
